var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.prefecture_id)?_c('Prefecture',{attrs:{"prefecture_id":_vm.prefecture_id}}):_c('Master')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }